import { render, staticRenderFns } from "./Home_old.vue?vue&type=template&id=3b31d854&scoped=true&"
import script from "./Home_old.vue?vue&type=script&lang=js&"
export * from "./Home_old.vue?vue&type=script&lang=js&"
import style0 from "./Home_old.vue?vue&type=style&index=0&id=3b31d854&scoped=true&lang=less&"
import style1 from "./Home_old.vue?vue&type=style&index=1&id=3b31d854&scoped=true&lang=less&"
import style2 from "./Home_old.vue?vue&type=style&index=2&id=3b31d854&scoped=true&lang=less&"
import style3 from "./Home_old.vue?vue&type=style&index=3&id=3b31d854&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b31d854",
  null
  
)

export default component.exports